import type { OnboardingHint } from './hints/onboarding';
import { onboardingHints, onboardingHintsMeta } from './hints/onboarding';
import type { ReportsHint } from './hints/reports';
import { reportsHints, reportsHintsMeta } from './hints/reports';

export const USER_HINTS = [...onboardingHints, ...reportsHints];
export const HINT_META_DATA = {
  ...onboardingHintsMeta,
  ...reportsHintsMeta,
};
export type HintKey = OnboardingHint | ReportsHint;
